import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Dropzone from "react-dropzone"; // For drag and drop image upload
import { addStaff, fetchStaff, updateStaff } from "../../../slices/admin/staffSlice";
import '../../../dropZone.css';
import { fetchRoles } from "../../../slices/admin/rolesSlice";

const AddEditAdminStaff = ( ) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const location = useLocation(); // Get location object to access the state
    const staffData = location.state?.staffData; 
    // Form state management
    const [name, setName] = useState(staffData?.name || "");
    const [email, setEmail] = useState(staffData?.email || "");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [roleId, setRoleId] = useState(staffData?.roleId || ""); // Assuming roleId is passed as part of staffData
    const [image, setImage] = useState(staffData?.image || null);
    const { roles } = useSelector((state) => state.adminRoles) || {};

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        // Validate form (e.g., ensure passwords match)
        if (password !== confirmPassword) {
            alert("Passwords do not match!");
            return;
        }

        const staffDataToSubmit = {
            name,
            email,
            roleId,
            image,
            is_admin: 0,
            ...(staffData ? {} : { password }), // Add is_admin only if it's not editing (when staffData doesn't exist)
        };
        

        if (staffData?.id) {
            // Update staff
            dispatch(updateStaff({id: staffData?.id, staffData:staffDataToSubmit}));
        } else {
            // Add new staff
            dispatch(addStaff(staffDataToSubmit));
        }
        dispatch(fetchStaff()); //

        // Redirect to staff list or desired page
        navigate("/admin/staff");
    };

    useEffect(() => {
        dispatch(fetchRoles());
    }, [dispatch]);

    // Handle image drag & drop
    const handleImageDrop = (acceptedFiles) => {
        const file = acceptedFiles[0];
        setImage(URL.createObjectURL(file)); // Set the image preview URL
    };

    return (
        <div className="row">
            <div className="col-xl-12 col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="card-title">{staffData?.id ? "Edit Staff" : "Add Staff"}</h4>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">

                                {/* Image Upload */}
                                <div className="col-md-4 mb-3">
                                    <label>Image</label>
                                    <Dropzone onDrop={handleImageDrop} accept="image/*">
                                        {({ getRootProps, getInputProps }) => (
                                            <div {...getRootProps()} className="dropzone">
                                                <input {...getInputProps()} />
                                                {image ? (
                                                    <img
                                                        src={image}
                                                        alt="Staff"
                                                        style={{ width: "150px", height: "150px", borderRadius: "50%" }}
                                                    />
                                                ) : (
                                                    <p>Drag & Drop image or click to select</p>
                                                )}
                                            </div>
                                        )}
                                    </Dropzone>
                                </div>

                                {/* Name */}
                                <div className="col-md-6 mb-3">
                                    <div className="row">
                                        <div className="col-md-12 mb-3">
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label>Email</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label>Role</label>
                                            <select
                                                className="form-control"
                                                value={roleId}
                                                onChange={(e) => setRoleId(e.target.value)}
                                                required
                                            >
                                                {/* Add role options dynamically */}
                                                <option value="">Select Role</option>
                                                {roles && roles.map((data) => (
                                                    <option key={data.id} value={data.id}>
                                                        {data.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                </div>

                                {/* Email */}


                                {/* Password */}
                                {staffData?.id?(<></>):(<div className="col-md-6 mb-3">
                                    <label>Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </div>)}

                                {/* Confirm Password */}
                               {staffData?.id?(<></>):( <div className="col-md-6 mb-3">
                                    <label>Confirm Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                    />
                                </div>)}

                                {/* Role */}


                                {/* Submit Button */}
                                <div className="col-md-6">
                                    <button type="submit" className="btn btn-primary btn-block">
                                        {staffData?.id?'Update':"Submit"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddEditAdminStaff;
